import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import { AppRoutes } from '../../utils/props';

type AccountTopBarProps = {
  showNav?: boolean;
};

const AccountTopBar: React.FC<AccountTopBarProps> = ({ showNav = true }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { label: 'Personal Information', href: AppRoutes.PersonalInformation },
    { label: 'Documents', href: AppRoutes.Documents },
  ];

  const currentLink = links.find((link) => link.href === location.pathname) ?? links[0];

  return (
    <div className="w-full bg-blue-600 py-4 pl-5 pr-5 md:pl-[52px] lg:pr-[190px] lg:pl-[222px]">
      <div className="flex items-center justify-between">
        <span
          className="text-white"
          style={{ fontFamily: 'Avenir, inherit', fontSize: '48px', fontWeight: 700, lineHeight: 'normal' }}
        >
          My Account
        </span>
        {showNav && (
          <nav className="hidden gap-6 md:flex">
            {links.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-center text-white transition hover:underline"
                  style={{
                    fontFamily: 'Avenir, inherit',
                    fontSize: '18px',
                    fontWeight: isActive ? 700 : 400,
                    lineHeight: 'normal',
                  }}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
      {showNav && (
        <div className="mt-3 md:hidden">
          <Menu as="div" className="relative">
            <Menu.Button className="flex w-full items-center justify-between rounded bg-blue-500 px-4 py-2 text-sm font-semibold text-white">
              {currentLink.label}
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="shrink-0"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </Menu.Button>
            <Menu.Items className="absolute z-10 mt-1 w-full overflow-hidden rounded bg-blue-500 shadow-lg focus:outline-none">
              {links.map((link) => (
                <Menu.Item key={link.href}>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={() => navigate(link.href)}
                      className={`block w-full px-4 py-2 text-left text-sm text-white ${
                        active ? 'bg-blue-600' : ''
                      } ${location.pathname === link.href ? 'font-semibold' : ''}`}
                    >
                      {link.label}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Menu>
        </div>
      )}
    </div>
  );
};

export default AccountTopBar;
